import { BaseLookupModel, PaginationFilterRequest } from '@/models/core.model';
import { utcToJSDate } from '@/utils/date-time';

export type SpecificType = FirstCityVisitAchievementType | FirstCountryVisitAchievementType | DiscoveryPointAchievementType | RouteAchievementType | MarathonAchievementType | RunEventAchievementType | CityDistrictAchievementType | null; 
export type UpsertSpecificType = UpsertFirstCityVisitAchievementType | UpsertFirstCountryVisitAchievementType | UpsertDiscoveryPointAchievementType | UpsertRouteAchievementType | UpsertMarathonAchievementType | UpsertRunEventAchievementType | UpsertCityDistrictAchievementType | null; 

export function userAchievementFromJson (json: any): Achievement {
  return {
    ...json,
    achievedAt: utcToJSDate(json.achievedAt)!
  } as Achievement;
};

export interface Achievement {
  id: number;
  name: string;
  iconUrl: string;
  type: AchievementTypeEnum;
  supportingCountryId?: number;
  supportingCityId?: number;
  uniqueNumber?: number;
}
export interface UserAchievement extends Achievement {
  achievedAt?: Date;
  supportingCountry?: BaseLookupModel;
  supportingCity?: BaseLookupModel;  
}

export interface UpsertAchievement {
  id?: number;
  name?: string;
  iconUrl?: string;
  type?: AchievementTypeEnum;
  supportingCountryId?: number;
  supportingCityId?: number;
  uniqueNumber?: number;
}

export const getMainPart = (achievement: Achievement&SpecificType) : Achievement => {
  return {
    id: achievement.id,
    name: achievement.name,
    type: achievement.type,
    iconUrl: achievement.iconUrl,
    supportingCityId: achievement.supportingCityId,
    supportingCountryId: achievement.supportingCountryId,
    uniqueNumber: achievement.uniqueNumber,
  };
};
export const getSpecificPart = (achievement: Achievement&SpecificType) : SpecificType => {
  switch (achievement.type){
    case AchievementTypeEnum.FirstCityVisit :
      return {
        cityId: (achievement as FirstCityVisitAchievementType).cityId,
      };
    case AchievementTypeEnum.FirstCountryVisit :
      return {
        countryId: (achievement as FirstCountryVisitAchievementType).countryId
      };
      case AchievementTypeEnum.MultiCityVisit :
        return null;
        case AchievementTypeEnum.MultiCountryVisit :
          return null;
      case AchievementTypeEnum.DiscoveryPoint :
        return {
          discoveryPointId: (achievement as DiscoveryPointAchievementType).discoveryPointId
        };
      case AchievementTypeEnum.Routes :
        return {
          routeId: (achievement as RouteAchievementType).routeId
        };
      case AchievementTypeEnum.Marathon :
        return {
          marathonId: (achievement as MarathonAchievementType).marathonId,
          marathonDistanceId: (achievement as MarathonAchievementType).marathonDistanceId
        };
      case AchievementTypeEnum.Event :
        return {
          runEventId: (achievement as RunEventAchievementType).runEventId,
          runEventDistanceId: (achievement as RunEventAchievementType).runEventDistanceId
        };
      case AchievementTypeEnum.District :
        return {
          districtId: (achievement as CityDistrictAchievementType).districtId,
        };
    default: 
      return null;
  }
};

export interface FirstCityVisitAchievementType{
  cityId: number ;
}
export interface UpsertFirstCityVisitAchievementType{
  cityId?: number ;
}

export interface FirstCountryVisitAchievementType{
  countryId: number ;
}
export interface UpsertFirstCountryVisitAchievementType{
  countryId?: number ;
}

export interface DiscoveryPointAchievementType{
  discoveryPointId: number ;
}
export interface UpsertDiscoveryPointAchievementType{
  discoveryPointId?: number ;
}

export interface RouteAchievementType{
  routeId: number ;
}
export interface UpsertRouteAchievementType{
  routeId?: number ;
}

export interface MarathonAchievementType{
  marathonId: number ;
  marathonDistanceId: number ;
}
export interface UpsertMarathonAchievementType{
  marathonDistanceId?: number ;
}

export interface RunEventAchievementType{
  runEventId: number ;
  runEventDistanceId: number ;
}
export interface UpsertRunEventAchievementType{
  runEventDistanceId?: number ;
}

export interface CityDistrictAchievementType{
  districtId: number ;
}
export interface UpsertCityDistrictAchievementType{
  districtId?: number ;
}


export class AchievementPaginationFilterRequest extends PaginationFilterRequest{  
  type?: AchievementTypeEnum;
  cityId?: number;
  countryId?: number;
}

export class UserAchievementPaginationFilterRequest extends AchievementPaginationFilterRequest{  
  userId!: number;
}

export enum AchievementTypeEnum
{
    Record = 1,
    Strikes = 2,
    Marathon = 3,
    Event = 4,
    Routes = 5,
    Activity = 6,
    Distance = 7,
    FirstCityVisit = 8,
    FirstCountryVisit = 9,
    DiscoveryPoint = 10,
    District = 11,
    MultiCityVisit = 12,
    MultiCountryVisit = 13,
}
export const AchievementTypeList =
[
  {value:1, label:"Record"},
  {value:2, label:"Strikes"},
  {value:3, label:"Marathon"},
  {value:4, label:"Event"},
  {value:5, label:"Routes"},
  {value:6, label:"Activity"},
  {value:7, label:"Distance"},
  {value:8, label:"First City Visit"},
  {value:9, label:"First Country Visit"},
  {value:10, label:"Discovery Point"},
  {value:11, label:"District"},
  {value:12, label:"Multi City Visit"},
  {value:13, label:"Multi Country Visit"},
];